import { Sizes } from './sizing';

export const control = {
  border: {
    color: 'gray-300',
    radius: Sizes[12],
    width: '1px',
  },
  disabled: {
    opacity: 'weak',
  },
  debounceDelay: 300,
};
